module.exports = __webpack_public_path__ + "static/media/icon_faq.a3c64a9a.svg";